import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const EMPTY = { name: "", contact_name: "", email: "", phone: "", abn: "", address: "", payment_terms: "", notes: "" };
const FIELDS = [["name", "Business name *"], ["contact_name", "Contact name"], ["email", "Email"], ["phone", "Phone"], ["abn", "ABN"], ["payment_terms", "Payment terms"]];

export const CustomerDialog = ({ open, onOpenChange, customer, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (open) setF(customer ? { ...EMPTY, ...customer } : EMPTY); }, [open, customer]);

  const submit = async (e) => {
    e.preventDefault();
    const body = Object.fromEntries(Object.keys(EMPTY).map((k) => [k, f[k] || ""]));
    try {
      customer ? await api.put(`/customers/${customer.id}`, body) : await api.post("/customers", body);
      toast.success("Customer saved");
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" aria-describedby={undefined} data-testid="customer-dialog">
        <DialogHeader><DialogTitle>{customer ? "Edit customer" : "New customer"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <div key={k}><Label>{l}</Label><Input required={k === "name"} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`customer-${k}-input`} /></div>
          ))}
          <div className="sm:col-span-2"><Label>Address</Label><Textarea rows={2} value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className="mt-1.5" data-testid="customer-address-input" /></div>
          <div className="sm:col-span-2"><Label>Notes</Label><Textarea rows={2} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} className="mt-1.5" data-testid="customer-notes-input" /></div>
          <DialogFooter className="sm:col-span-2">
            <Button type="submit" className="bg-[#01195D] hover:bg-[#0A2A7A]" data-testid="customer-save-btn">Save customer</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
